module.exports = __webpack_public_path__ + "static/media/viewPDF.cac42f0c.jpeg";